export default __webpack_public_path__ + "static/media/telefono_footer.eb279b88.svg";